import React, { useEffect, useState } from 'react';
import Header from '../components/header';
import Newsletter from '../components/newsLetter';
import Footer from '../components/footer';
import DashboardInsights from '../components/dashboardInsights';
import { useLocation } from 'react-router-dom';
import '../../src/App.css';

const Services = () => {
  const [activeTab, setActiveTab] = useState('regulatory');
  const location = useLocation();
  type TabId = 'regulatory' | 'innovation' | 'fractional' | 'infrastructure';

  const tabs = [
    { id: 'regulatory', label: 'Regulatory Consulting', path: 'regulatory-consulting' },
    { id: 'innovation', label: 'Innovation Consulting', path: 'innovation-consulting' },
    { id: 'fractional', label: 'Fractional C-Suite', path: 'fractional-c-suite' },
    { id: 'infrastructure', label: 'Infrastructure Build', path: 'infrastructure-build' },
  ];

  const servicesContent = {
    regulatory: {
      description: [
        `Navigating the regulatory landscape in uncertain times can be challenging.  Our deeply seasoned experts can work with you to chart the most optimal course.  Our practice areas span across asset classes providing a range of regulatory compliance services to banks (Federal and State chartered), broker dealers, swaps, derivatives and forex brokers, and fintechs.  We also specialize in advising blockchain projects, structuring securities token offerings (STOs), and cryptocurrency related firms.  We have experience working with Federal and State regulators, including the Securities Exchange Commission (SEC), Commodity Futures Trading Commission (CFTC), FINRA, and Office of the Comptroller of the Currency (OCC).  We also work with global regulators on blockchain-related projects.`,
      ],
      services: [
        "Bank Secrecy Act (BSA), anti-money laundering (AML), sanctions, Foreign Corrupt Practices Act (FCPA) compliance",
        "Mock regulatory exams",
        "Preparing new broker/dealers FINRA and NFA registrations, form filings, and advertising review",
        "Compliance Management System reviews",
        "Policy development and assessment",
        "Compliance lookbacks and remediation",
        "Trading and market making review with best execution and fairness",
        "Customer complaint reviews",
        "UDAAP review",
        "Implementation review for consumer protection laws",
        "Compliance risk assessments",
        "AML / Sanctions program development and audits",
        "Compliance and regulatory training"
      ]
    },

    innovation: {
      description: [
        `Staying ahead of market structure changes means that companies must start thinking about and incorporating emerging technologies, market trends, and new growth opportunities into their present-day strategies.  Business Risk and the Control Environment must keep pace with the blistering speed of technological innovation.  We help our clients to understand and adapt their current business.  We provide insights and guidance from idea formation, through incubation and to scale.  Our experts can create bespoke ideation sessions, inclusive of regulatory insights, to help you identify new opportunities while future proofing your current roadmaps and vision.`
      ],
      services: [
        "Ideation and concept formation",
        "Regulatory ideation",
        "Pitch deck development and coaching",
        "Capital raising strategy",
        "Product roadmap assessment",
        "Innovation strategy development",
        "Entrepreneur in resident (search and placement)",
        "Provide seed capital",
        "Assist with all stages of fundraising"
      ]
    },

    fractional: {
      description: [
        `Navigating the regulatory landscape in uncertain times can be challenging.  Our deeply seasoned experts can work with you to chart the most optimal course.  Our practice areas span across asset classes providing a range of regulatory compliance services to banks (Federal and State chartered), broker dealers, swaps, derivatives and forex brokers, and fintechs.  We also specialize in advising blockchain projects, structuring securities token offerings (STOs), and cryptocurrency related firms.  We have experience working with Federal and State regulators, including the Securities Exchange Commission (SEC), Commodity Futures Trading Commission (CFTC), FINRA, and Office of the Comptroller of the Currency (OCC).  We also work with global regulators on blockchain-related projects.`,
      ],
      services: [
        "Bank Secrecy Act (BSA), anti-money laundering (AML), sanctions, Foreign Corrupt Practices Act (FCPA) compliance",
        "Mock regulatory exams",
        "Preparing new broker/dealers FINRA and NFA registrations, form filings, and advertising review",
        "Compliance Management System reviews",
        "Policy development and assessment",
        "Compliance lookbacks and remediation",
        "Trading and market making review with best execution and fairness",
        "Customer complaint reviews",
        "UDAAP review",
        "Implementation review for consumer protection laws",
        "Compliance risk assessments",
        "AML / Sanctions program development and audits",
        "Compliance and regulatory training"
      ]
    },

    infrastructure: {
      description: [
        `Navigating the regulatory landscape in uncertain times can be challenging.  Our deeply seasoned experts can work with you to chart the most optimal course.  Our practice areas span across asset classes providing a range of regulatory compliance services to banks (Federal and State chartered), broker dealers, swaps, derivatives and forex brokers, and fintechs.  We also specialize in advising blockchain projects, structuring securities token offerings (STOs), and cryptocurrency related firms.  We have experience working with Federal and State regulators, including the Securities Exchange Commission (SEC), Commodity Futures Trading Commission (CFTC), FINRA, and Office of the Comptroller of the Currency (OCC).  We also work with global regulators on blockchain-related projects.`,
      ],
      services: [
        "Bank Secrecy Act (BSA), anti-money laundering (AML), sanctions, Foreign Corrupt Practices Act (FCPA) compliance",
        "Mock regulatory exams",
        "Preparing new broker/dealers FINRA and NFA registrations, form filings, and advertising review",
        "Compliance Management System reviews",
        "Policy development and assessment",
        "Compliance lookbacks and remediation",
        "Trading and market making review with best execution and fairness",
        "Customer complaint reviews",
        "UDAAP review",
        "Implementation review for consumer protection laws",
        "Compliance risk assessments",
        "AML / Sanctions program development and audits",
        "Compliance and regulatory training"
      ]
    }
  };


  useEffect(() => {
    const lastSegment = location.pathname.split('/').pop();
    const matchedTab = tabs.find(tab => tab.path === lastSegment);
    if (matchedTab) {
      setActiveTab(matchedTab.id);
    }else{
      setActiveTab('regulatory');
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen">
      
      {/* Hero Section */}
      <section className="relative pt-16 min-h-[400px] overflow-hidden">
  <img
    src="/blue-insights-background.png"
    alt=""
    className="absolute inset-0 w-full h-full object-cover z-0"
  />
  <div className="relative mx-auto px-4 sm:px-6 lg:px-8 py-20 h-[494px]">
    <div className="max-w-2xl">
      <h1 className="text-white mb-6 font-normal text-[34px] leading-[44px] sm:text-[48px] sm:leading-[60px] md:text-[62px] md:leading-[76px] tracking-[0px]">
        Empowering doers<br />
        building future
      </h1>

      <p className="font-normal max-w-[500px] text-[16px] leading-[24px] sm:text-[18px] sm:leading-[26px] md:text-[20px] md:leading-[27.12px] tracking-[0px] text-white mt-[40px] sm:mt-[60px] md:mt-[90px] mb-[20px] sm:mb-[30px]">
        We are creating an ecosystem of "doers" to help build the businesses of the future
      </p>

      <button className="group bg-transparent text-white py-3 transition-all duration-300 text-sm font-medium tracking-wider inline-flex items-center" onClick={() => window.location.href = '/contact'}>
              LET'S BUILD TOGETHER
              <svg
                className="ml-2 transform transition-transform duration-300 group-hover:translate-x-2"
                width="15"
                height="12"
                viewBox="0 0 15 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L9.75736 0.6967C9.46447 0.403807 8.98959 0.403807 8.6967 0.6967C8.40381 0.989593 8.40381 1.46447 8.6967 1.75736L12.9393 6L8.6967 10.2426C8.40381 10.5355 8.40381 11.0104 8.6967 11.3033C8.98959 11.5962 9.46447 11.5962 9.75736 11.3033L14.5303 6.53033ZM0 6L-6.55671e-08 6.75L14 6.75L14 6L14 5.25L6.55671e-08 5.25L0 6Z"
                  fill="white"
                />
              </svg>
            </button>
    </div>
  </div>
</section>


      {/* Expertise Section */}
      <section className="py-16 bg-white">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 mb-16">
            <div>
              <h2 className="font-light text-[62px] leading-[79.49px] tracking-[0px] random-colors-text">
                Explore our Expertise
              </h2>
            </div>
            <div>
              <p className="font-normal text-[22px] leading-[32.73px] tracking-[0px] mb-6" >
                From ideation to execution, our expertise is your competitive edge in 
                building smarter, faster, and more resilient solutions.
              </p>
              <p className="font-normal text-[22px] leading-[32.73px] tracking-[0px]" >
                Explore how our deep expertise and innovative thinking come together 
                to solve real business challenges and drive measurable growth.
              </p>
            </div>
          </div>

          {/* Tab Navigation */}
          <div className="border-b border-gray-200 mb-12">
            <nav className="flex space-x-4 sm:space-x-8">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`py-4 border-b-2 font-medium text-sm sm:text-[18px] transition-colors ${
                    activeTab === tab.id
                      ? 'border-customTeal text-customTeal'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Tab Content */}
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div>
              {servicesContent[activeTab as TabId]?.description.map((para : any, index : any) => (
                <p key={index} className="text-[18px] font-normal leading-[26.7px]">
                  {para}
                </p>
              ))}

              <div className="mb-8 mt-6">
                <h3 className="text-[22.87px] font-medium leading-[38.17px] mb-2">Services</h3>
                <ul className="text-[18px] leading-[26.7px]">
                  {servicesContent[activeTab as TabId]?.services.map((item : any, index : any) => (
                    <li key={index} className="flex items-start">
                      <span className="mr-2">•</span>
                      <span className="block">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button className="group bg-transparent text-black py-3 transition-all duration-300 text-sm font-medium tracking-wider inline-flex items-center" onClick={() => window.location.href = '/contact'}>
              LET'S BUILD TOGETHER
              <svg
                className="ml-2 transform transition-transform duration-300 group-hover:translate-x-2"
                width="15"
                height="12"
                viewBox="0 0 15 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.5303 6.53033C14.8232 6.23744 14.8232 5.76256 14.5303 5.46967L9.75736 0.6967C9.46447 0.403807 8.98959 0.403807 8.6967 0.6967C8.40381 0.989593 8.40381 1.46447 8.6967 1.75736L12.9393 6L8.6967 10.2426C8.40381 10.5355 8.40381 11.0104 8.6967 11.3033C8.98959 11.5962 9.46447 11.5962 9.75736 11.3033L14.5303 6.53033ZM0 6L-6.55671e-08 6.75L14 6.75L14 6L14 5.25L6.55671e-08 5.25L0 6Z"
                  fill="black"
                />
              </svg>
            </button>
            </div>

            <div>
              <img
                src="/expertise-image.png"
                alt="Professional consultant"
                className="h-[729px] w-full object-cover"
              />
            </div>
          </div>

        </div>
      </section>

      
      <DashboardInsights/>
      <Newsletter />
    </div>
  );
};

export default Services;